import { take } from 'redux-saga/effects';
import { reduxModuleLoaded } from '../actions';
import rootSaga from './index';

export function* moduleLoadableSaga() {
  yield take(reduxModuleLoaded); // wait for the dynamic redux module to load
  yield rootSaga();
}
